var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[_c('Header'),_c('div',{staticClass:"app-container container"},[_c('router-view',{staticClass:"app-main"}),_c('Right',{staticClass:"hidden-xs"})],1),_c('Footer'),_c('el-backtop',{attrs:{"bottom":80}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }